import * as ExportedIcons from './generated';
export var Icons = ExportedIcons;